module.exports = " <div class=\"card p-0\"> <div class=card-body> <publish-fields :fields=fields :data.sync=data :errors=errors :hidden-fields=hiddenFields :autofocus=autofocus :regular-title-field=!metaFields :env=env></publish-fields> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/publish/Section.vue
// module id = 388
// module chunks = 0